export default __webpack_public_path__ + "static/media/header.c9dc0733.png";